module.exports = __webpack_public_path__ + "img/logoPrincipalClaim.7ccff3f9.png";